import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api } from '../Services/api'
import userData from './UserData'
import storageSession from 'redux-persist/lib/storage/session';
import storage from 'redux-persist/lib/storage';

import { persistReducer } from 'redux-persist';
import productData from './ProductData';
import galleryData from './GalleryData';
import eventData from './EventData';

const persistConfig = {
  key: 'root',
  storage:storageSession,
};

const reducers = combineReducers({  
    userData,   
    productData,
    galleryData,
    eventData,
    api: api.reducer,
  })
  const persistedReducer = persistReducer(persistConfig, reducers);
export const store = configureStore({
  reducer: persistedReducer ,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});

setupListeners(store.dispatch);